import client from './client';

export const getPatientRecordsApi = params => client().get('/patient-meta-data', params);
export const getPatientThresholdApi = params => client().get('/patient-meta-data', { params });
export const createPatientRecordApi = ({ recheckRecommendation, ...params }) =>
  client().post('/patient-meta-data', params, { params: { recheckRecommendation } });

export const removePatientRecordsApi = id => client().delete(`/patient-meta-data/${id}`);
